import { AgreementDocumentType } from '../../../types/interfaces/agreement';

export const AGREEMENT_TYPE_PATH_SEGMENT: Record<
  AgreementDocumentType,
  string
> = {
  termsOfUse: 'terms-of-use',
  privacyPolicy: 'privacy-policy',
  cookiePolicy: 'cookie-policy',
};

export function agreementTypeFromPathSegment(
  segment: string | undefined,
): AgreementDocumentType | null {
  if (!segment) return null;
  const found = Object.entries(AGREEMENT_TYPE_PATH_SEGMENT).find(
    ([, pathSegment]) => pathSegment === segment,
  );
  return found ? (found[0] as AgreementDocumentType) : null;
}
